import React, { useEffect, useRef } from 'react'
import useStyles from './styles'
import { Typography, Chip } from '@material-ui/core'
import { formatMoney } from 'accounting'
import { useSelector } from 'react-redux'
import classnames from 'clsx'
import TextClamp from 'react-string-clamp'
import useNameStyle from 'hooks/useNameStyle'

const Bid = ({ bid, scrollEffect = false, parentRef, winningBid = false }) => {
  const classes = useStyles()
  const bidRef = useRef(null)
  let parentHeight = 0

  const calculateScrollEffect = () => {
    const bottomOffset = bidRef.current.offsetTop + bidRef.current.offsetHeight
    bidRef.current.style.opacity = bottomOffset / parentHeight
  }

  const bidId = useSelector(state => state.items.bidIds[bid.user_id])

  let styledName = useNameStyle(bid.user_name)
  if (bid.anon === 1 || bid.anon === '1') {
    styledName = useNameStyle('Anonymous')
  }

  useEffect(() => {
    if (scrollEffect) {
      parentHeight = Math.round(parentRef.current.clientHeight)
      calculateScrollEffect()
    }
  }, [scrollEffect])

  return (
    <figure
      className={classnames(classes.bid, {
        [classes.winningBid]: winningBid
      })}
    >
      {styledName === 'paddle_number' && (
        <Chip className={classes.chip} color="primary" label={bidId} />
      )}
      <Typography variant="h3" className={classes.bidderName}>
        <TextClamp
          text={styledName === 'paddle_number' ? '' : styledName}
          lines={1}
        />
      </Typography>
      <Typography variant="h3" className={classes.bidAmount}>
        {formatMoney(bid.bid_amt, '$', 0)}
      </Typography>
    </figure>
  )
}

export default Bid

// import React from "react"
// import useStyles from "./styles"
// import { Card, CardContent, Typography, Button, Chip } from "@material-ui/core"
// import TextClamp from "react-string-clamp"
// import classnames from "clsx"
// import { formatMoney } from "accounting"
// import { useSelector } from "react-redux"

// const Bid = ({ bid }) => {
//   const classes = useStyles()

//   const bidIds = useSelector(state => state.items.bidIds)

//   return (
//     <figure className={classes.bid}>
//       <Chip
//         className={classes.chip}
//         color="primary"
//         label={bidIds[bid.user_id]}
//       />
//       <Typography variant="h4" className={classes.bidderName}>
//         {bid.user_name || bid.user_phone}
//       </Typography>
//       <Typography className={classes.bidAmount}>
//         {formatMoney(bid.bid_amt, "$", 0)}
//       </Typography>
//     </figure>
//   )
// }

// export default Bid



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/BidList/Bid/index.jsx